import { Box, Button, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import { deleteGame, getListOfGames, getListOfGroups, resetAllWinner } from '../AdminMenusRequests';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { SmallModal } from '../../../CustomModal/SmallModal';
import { AddGames } from './AddGames';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { orange } from '@mui/material/colors';
import toast from 'react-hot-toast';
import { UpdateGames } from './UpdateGames';
import { AddWinner } from './AddWinner';
import Swal from 'sweetalert2';

export const ListOfGames = ({close,updateScoreBoard}) => {
    const [listOfGames,setListOfGames] = useState([]);
    const [listOfGroups,setListOfGroups] = useState([]);
    const [selectedGame,setSelectedGame] = useState();

    useEffect(()=>{
        _init();
        _getGroups();
    },[])
    const _init = async () => {
        const res = await getListOfGames()
        setListOfGames(res.data.data)
    }
    const _getGroups = async () => {
        const res = await getListOfGroups();
        res.data.data.push({
            id:0,
            group_name:'NONE'
        })
        setListOfGroups(res.data.data)
    }
    const [openAddModal,setOpenAddModal] = useState(false)
    const [openUpdateModal,setOpenUpdateModal] = useState(false)
    const [openUpdateWinnerModal,setOpenUpdateWinnerModal] = useState(false)
    const handleDelete = async (item)=>{
        const toastId = toast.loading('Deleting game'); 
        const res  = await deleteGame({id:item.id});
        if(res.data.status === 200){
            setListOfGames(res.data.data)
            updateScoreBoard()
            toast.success(res.data.message,{
                id:toastId
            });
        }else{
            toast.error(res.data.message,{
                id:toastId
            });
        }
    }
    const handleUpdate = (item) => {
        setSelectedGame(item)
        setOpenUpdateModal(true)

    }
    const handleUpdateWinner = (item)=>{
        setSelectedGame(item)
        setOpenUpdateWinnerModal(true)
    }
    const handleResetWinner = () => {
        Swal.fire({
            icon:'question',
            title:'Confirm reseting winner ?',
            text:'Action cannot be reverted',
            confirmButtonText:'Yes, I Confirm it !',
            cancelButtonText:'No, Cancel it !',
            showCancelButton:true
        }).then( async res=>{
            if(res.isConfirmed){
                const toastId = toast.loading('Resetting All Winners')

                const res = await resetAllWinner()
                if(res.data.status === 200){
                    setListOfGames(res.data.data)
                    updateScoreBoard()
                    toast.success(res.data.message,{
                        id:toastId
                    });
                }else{
                    toast.error(res.data.message,{
                        id:toastId
                    });
                }
            }
        })
    }
    return (
        <Grid container>
            <Grid item xs={12} sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography>List Of Games</Typography>
                <Box sx={{display:'flex',gap:1}}>
                    <Button variant='outlined' color='secondary' startIcon={<RestartAltIcon/>} onClick={handleResetWinner}>Reset Winner/s</Button>
                    <Button variant='outlined' startIcon={<AddIcon/>} onClick={()=>setOpenAddModal(true)}>Add</Button>

                </Box>
            </Grid>
            <Grid item xs={12}>
                <List>
                {
                    listOfGames.map((item)=>
                    <ListItem disablePadding
                        secondaryAction={
                            <Box sx={{display:'flex',gap:1}}>
                                <Tooltip title='Set Winner'>
                                    <IconButton aria-label="update-winner" className='icon-btn-bordered' onClick={()=>handleUpdateWinner(item)}>
                                        <EmojiEventsIcon aria-label="winner" sx={{color:orange[800]}} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title='Update'>
                                    <IconButton aria-label="edit" className='icon-btn-bordered'  color='success' onClick={()=>handleUpdate(item)}>
                                    <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title='Delete'>
                                    <IconButton aria-label="delete" className='icon-btn-bordered' color='error' onClick={()=>handleDelete(item)}>
                                    <DeleteIcon />
                                </IconButton>
                                </Tooltip>
                                
                            </Box>
                        }
                    >
                        <ListItemButton>
                        <ListItemText primary={item.game_name} secondary={`Winner: ${item.group_name?item.group_name:'N/A'}`}/>
                        </ListItemButton>
                    </ListItem>
                    )
                }
                </List>
            </Grid>
            <SmallModal open={openAddModal} close = {()=>setOpenAddModal(false)} title='Adding new Games'>
                <AddGames close={()=>setOpenAddModal(false)} setListOfGames ={setListOfGames} updateScoreBoard={updateScoreBoard}/>
            </SmallModal>
            <SmallModal open={openUpdateModal} close = {()=>setOpenUpdateModal(false)} title='Adding new Games'>
                <UpdateGames close={()=>setOpenUpdateModal(false)} setListOfGames ={setListOfGames} selectedGame={selectedGame} updateScoreBoard = {updateScoreBoard}/>
            </SmallModal>
            <SmallModal open={openUpdateWinnerModal} close = {()=>setOpenUpdateWinnerModal(false)} title='Updating game winner'>
                <AddWinner close={()=>setOpenUpdateWinnerModal(false)} listOfGroups={listOfGroups} setListOfGames ={setListOfGames} selectedGame={selectedGame} updateScoreBoard={updateScoreBoard}/>
            </SmallModal>
        </Grid>
    )
}